import React, { useEffect, useState } from "react";
import ImageCard from "../../../components/card/ImageCard";
import PageBanner from "../../../components/PageBanner";
import Pagination from "../../../components/Pagination";
import GalleryService from "../../../services/gallery";
import BannerService from "../../../services/banner";
import { useParams } from "react-router-dom";
import { gallerySize } from "../../../configs/pageSize";

export default function Gallery() {
  let [galleryData, setGalleryData] = useState([]);
  let [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);
  // eslint-disable-next-line
  const [pageSize, setPageSize] = useState(gallerySize);
  let [galleryBanner, setGalleryBanner] = useState([]);
  let { lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getGalleryBanner();
  }, []);

  useEffect(() => {
    getGalleryData();

    // eslint-disable-next-line
  }, [page, pageSize]);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const getGalleryData = async () => {
    try {
      let [res, meta] = await GalleryService.getGalleryBySize({
        page: page,
        pageSize: pageSize,
      });
      setGalleryData(res);
      setMeta(meta);
    } catch {
      console.error();
    }
  };

  const getGalleryBanner = async () => {
    try {
      let res = await BannerService.getBanner(8);
      setGalleryBanner(res);
    } catch {
      console.error();
    }
  };

  const bannerText = [{ name: "Gallery", href: "/gallery" }];

  return (
    <div id="gallery" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"ประมวลภาพกิจกรรม"}
        text_en={"Gallery"}
        banner={galleryBanner?.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* นัดหมาย */}
          <div className="mt-[92px] mb-[300px]">
            <h1 className="text-heading font-bold text-slateGray text-left">
              {lang === "th" ? "ประมวลภาพกิจกรรม" : "Gallery"}
            </h1>

            <div
              id="image-activity"
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:flex-row gap-[30px] mt-[68px]"
            >
              {galleryData &&
                galleryData.map((item, i) => (
                  <ImageCard data={item} key={i} lang={lang} />
                ))}
            </div>

            {galleryData && (
              <Pagination
                length={meta?.pagination?.pageCount ?? ""}
                selected={page}
                function={(i) => {
                  setPage(i);
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
